import { render, staticRenderFns } from "./MemoButton.vue?vue&type=template&id=55cf8672&scoped=true"
import script from "./MemoButton.vue?vue&type=script&lang=ts"
export * from "./MemoButton.vue?vue&type=script&lang=ts"
import style0 from "./MemoButton.vue?vue&type=style&index=0&id=55cf8672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55cf8672",
  null
  
)

export default component.exports